<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("screen_seat_type_group", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("sstg_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          variant="default"
          to="add-screen-seat-type-group"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>
    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <b-form-input
          v-debounce:500="getScreenSeatType"
          v-model="searchValue"
          placeholder="Search..."
        ></b-form-input>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class="mx-2">
          <b-dropdown
            :text="filterButtonTitle"
            variant="dropdown-curve"
            class="ml-auto mr-3 filter-dropdown"
          >
            <b-dropdown-item
              v-for="(status, statusIndex) in statuses"
              :key="statusIndex"
              v-on:click="filterStatus(status.status)"
              >{{ status.status }}</b-dropdown-item
            >
          </b-dropdown>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              <!-- Viewing&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp; -->
              <strong>{{ viewingRange }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>

        <button
          class="btnj btn-gridView mr-3"
          v-if="GridViewFlag"
          :class="gridView ? 'active' : ''"
          v-on:click="viewType('gridView')"
        ></button>
        <button
          class="btnj btn-listView"
          v-if="GridViewFlag"
          :class="listView ? 'active' : ''"
          v-on:click="viewType('listView')"
        ></button>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th class="text-left" style="width: 120px">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
          <th style="width: 200px">
            <img
              v-if="this.columnName != 'sstg_name'"
              @click="onSortValue('sstg_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('sstg_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('sstg_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("screen_seat_type_group", 1) }}
          </th>
        </tr>
      </thead>
      <template v-if="ScreenSeatTypes && ScreenSeatTypes.length > 0">
        <tbody>
          <tr v-for="(item, key) in ScreenSeatTypes" :key="key">
            <td>
              <div class="d-flex align-items-center justify-content-start">
                <StatusDot
                  :status="item.sstg_is_active == 'Y' ? 'active' : 'inactive'"
                />
                <div
                  class="ml-4 clickable-icon"
                  @click="
                    goToRoute('/master/edit-screen-seat-type-group', item)
                  "
                  style="cursor: pointer"
                  v-b-tooltip="'Edit'"
                  tabindex="0"
                >
                  <i class="edit-pen icon blue-icon"></i>
                </div>
              </div>
            </td>
            <td>{{ $tc(item.sstg_name, 1) }}</td>
          </tr>
        </tbody>
      </template>

      <tbody v-if="ScreenSeatTypes.length == 0">
        <tr>
          <td colspan="2">
            <NoRecords />
          </td>
        </tr>
      </tbody>
    </table>

    <b-pagination
      v-if="ScreenSeatTypes.length > 0"
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
import NoRecords from "@/components/Partials/NoRecords.vue";

export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
    NoRecords,
  },
  data() {
    return {
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",
      filterButtonTitle: "Active",
      statuses: [
        { status: "Active" },
        { status: "Inactive" },
        { status: "All" },
      ],
      selectedStatus: "Active",
      gridView: false,
      listView: true,
      ScreenSeatTypes: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },
      //Sorting data
      isSort: false,
      isAscending: true,
      orderby: "",
      columnName: "",

      debounce: null,
      searchValue: "",
      searchKey: "sstg_name",
    };
  },
  beforeMount() {
    this.getScreenSeatType();
    this.getviewingnumber();
  },
  computed: {
    viewingRange() {
      if (this.rows === 0) {
        return "Viewing 0 to 0 of 0";
      }

      const start = (this.currentPage - 1) * this.perPage + 1;
      const end = Math.min(this.currentPage * this.perPage, this.rows);

      return `Viewing ${start} to ${end} of ${this.rows}`;
    },
  },

  methods: {
    filterStatus: function (status) {
      this.filterButtonTitle = status;
      this.selectedStatus = status;
      this.getScreenSeatType();
    },
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },

    /* eslint-disable */
    onChangePagination: function (event) {
      if (event === undefined) {
        this.currentPage = 1;
        this.getScreenSeatType();
      } else {
        this.currentPage = event;
        this.getScreenSeatType();
      }
    },
    goToRoute: function (path, item) {
      const { sstg_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: sstg_id,
        },
      });
    },
    //Sort
    onSortValue(columnName, orderby) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderby = orderby;
      this.getScreenSeatType();
    },
    getScreenSeatType: function () {
      this.ScreenSeatTypes = [];
      let payload = {
        limit: this.perPage,
        currentPage: this.currentPage,
        searchKey: this.searchKey,
        searchValue: this.searchValue,
        orderBy: this.orderby,
        columnName: this.columnName,
        status: this.selectedStatus,
      };
      MasterService.GetAllScreenSeatTypeGroup(payload)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              this.ScreenSeatTypes = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              console.log("Error:", data.message);
              this.$toasted.show(data.message);
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ScreenSeatTypeGroup/ListScreenSeatTypeGroup.vue